"use client";
import React, { useEffect, useState } from "react";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
import Explorearticelskeleton from "@packages/shared-components/skeleton/search-result/explore-articel-skeleton";
import FeaturedSkeleton from "@packages/shared-components/skeleton/search-result/featured-skeleton";
import GradeBannerSkeleton from "@packages/shared-components/skeleton/search-result/grade-banner-skeleton";
import ResultSectionSkeleton from "@packages/shared-components/skeleton/search-result/result-section-skeleton";
import TopSectionSkeleton from "@packages/shared-components/skeleton/search-result/top-section-skeleton";
import SearchLabelsSkeleton from "@packages/shared-components/skeleton/search-result/search-labels-skeleton";
import SearchFilterButtonsSkeleton from "@packages/shared-components/skeleton/search-result/search-filter-buttons-skeleton";
const SearchPageSkeleton = () => {

  const [showSkeleton, setShowSkeleton] = useState(false);
  useEffect(() => {
    const searchPageLoading = (event: boolean) => {
      setShowSkeleton(event);
    };
    emitter.on("searchpageloading", searchPageLoading);
    return () => {
      emitter.off("searchpageloading", searchPageLoading);
    };
  }, []);
  if (!showSkeleton) return null;
  return (
    <>
      {showSkeleton && (
        <div
          className="fixed inset-0 z-[9999] bg-white top-[68px] scroll-block overflow-y-hidden"
          id="srpageskeleton"
        >
          <div className="max-w-container mx-auto px-[16px] md:px-[20px] xl:px-[0]">
            <TopSectionSkeleton />
          </div>
          <SearchFilterButtonsSkeleton />
          <SearchLabelsSkeleton />
          <div className="max-w-container mx-auto px-[16px] md:px-[20px] xl:px-[0]">
            <GradeBannerSkeleton />
            <Explorearticelskeleton />
            <FeaturedSkeleton />
            <ResultSectionSkeleton />
          </div>
        </div>
      )}
    </>
  );
};

export default SearchPageSkeleton;
